import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEmptySet } from '@fortawesome/pro-solid-svg-icons';
import './NoMatch.scss';

export const NoMatch = ({ recommendedAction }: { recommendedAction?: ReactNode }) => {
  return (
    <div className='no-match-page p-a-32'>
      <FontAwesomeIcon icon={faEmptySet} />
      <div className='title-l'>Nothing here!</div>
      <div className='text-m m-t-24'>
        What you are looking for either does not exist or you do not have permission to access it.
      </div>
      <div className='no-match-spacer' />
      <div className='title-s'>What should I do?</div>
      <div className='text-m m-t-16'>
        {recommendedAction ||
          'Navigate to any other page to get back. If you think this is a mistake and there should be something here, please contact Salv.'}
      </div>
    </div>
  );
};
